import React from "react";
import { Link } from "react-router-dom";
import { Shield, Mail, ArrowLeft } from "lucide-react";
import SakuraDivider from "@/components/SakuraDivider";

export default function Privacy() {
  return (
    <div data-testid="page-privacy">
      <section className="section">
        <div className="mx-auto max-w-4xl">
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-sakura-500 hover:underline mb-5"><ArrowLeft className="h-4 w-4" /> Back home</Link>
          <div className="flex items-center gap-3">
            <span className="h-12 w-12 grid place-items-center rounded-full bg-sakura-200 text-sakura-500"><Shield className="h-5 w-5" /></span>
            <h1 className="font-serif text-4xl sm:text-5xl text-sakura-ink">Privacy Policy</h1>
          </div>
          <p className="mt-3 text-sm text-sakura-soft">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
          <SakuraDivider className="my-8" />

          <div className="prose prose-sakura max-w-none space-y-6 text-sakura-ink">
            <p>
              Sakura Treats ("we," "our," "us") is a small home-based custom treat business
              operated by Kaitlyn in Spring Hill, Florida. This Privacy Policy explains what
              information we collect when you visit this website or submit an order inquiry,
              how we use it, and the choices you have.
            </p>

            <h2 className="font-serif text-2xl text-sakura-ink">1. Information we collect</h2>
            <ul className="list-disc pl-5 space-y-2 text-sakura-soft">
              <li><b>Contact & inquiry info:</b> name, email, phone, event date, event type, theme/colors, treats requested, budget range, notes, and optional inspiration photos you upload.</li>
              <li><b>Payment info:</b> processed directly by Stripe. We never see or store your full card number or CVV. We do keep your name, email, the amount paid, a Stripe session ID, and a "paid/unpaid" status.</li>
              <li><b>Basic technical info:</b> we may log anonymous analytics (pages visited) to help improve the site.</li>
            </ul>

            <h2 className="font-serif text-2xl text-sakura-ink">2. How we use your info</h2>
            <ul className="list-disc pl-5 space-y-2 text-sakura-soft">
              <li>To reply to your inquiry with a quote and finalize order details.</li>
              <li>To send you an order confirmation and (if applicable) a deposit payment link.</li>
              <li>To process deposit payments through Stripe.</li>
              <li>To keep a simple record of past orders for tax and bookkeeping purposes.</li>
            </ul>
            <p>
              We do <b>not</b> sell your information and we do <b>not</b> send marketing
              emails unless you explicitly ask us to.
            </p>

            <h2 className="font-serif text-2xl text-sakura-ink">3. Who we share with</h2>
            <ul className="list-disc pl-5 space-y-2 text-sakura-soft">
              <li><b>Stripe</b> — for payment processing (see stripe.com/privacy).</li>
              <li><b>Resend</b> — for sending transactional emails (inquiry confirmations).</li>
              <li><b>Service providers</b> that host the website infrastructure.</li>
            </ul>

            <h2 className="font-serif text-2xl text-sakura-ink">4. Data retention</h2>
            <p className="text-sakura-soft">
              We keep inquiry records and payment records as long as needed to fulfill the
              order and meet tax/record-keeping requirements. You may request deletion by
              emailing us at <a href="mailto:sakuratreats.shop@gmail.com" className="text-sakura-500 underline">sakuratreats.shop@gmail.com</a>.
            </p>

            <h2 className="font-serif text-2xl text-sakura-ink">5. Cookies</h2>
            <p className="text-sakura-soft">
              We use essential cookies to keep admin sessions logged in and may use basic
              analytics cookies. No ad-tracking cookies.
            </p>

            <h2 className="font-serif text-2xl text-sakura-ink">6. Your rights</h2>
            <p className="text-sakura-soft">
              You may ask us what we have on file, correct it, or delete it at any time by
              emailing us.
            </p>

            <h2 className="font-serif text-2xl text-sakura-ink">7. Children</h2>
            <p className="text-sakura-soft">
              This site is not directed to children under 13 and we do not knowingly collect
              their information.
            </p>

            <h2 className="font-serif text-2xl text-sakura-ink">8. Contact</h2>
            <p className="text-sakura-soft">
              Questions? <Mail className="inline h-4 w-4 mx-1 text-sakura-500" />
              <a href="mailto:sakuratreats.shop@gmail.com" className="text-sakura-500 underline">sakuratreats.shop@gmail.com</a> · Spring Hill, FL.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
